<template>
  <div class="knd-header">
    <div class="knd-header__bg">
      <canvas id="canvas" ref="canvas"></canvas>

      <svg class='knd-header__bg_svg' viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
        <circle cx="50" cy="50" r="50"/>
      </svg>  

      <!-- <div class="knd-header__quote">
        "Het spreekt vanzelf, maar het is niet toegestaan om richting de klant aan te geven dat de berichten van betaalde operators komen."
      </div> -->

      <img style="left: 20rem; top: 2rem" class="knd-header__bg_img animate-pulse" src="@/assets/images/header-bubble-2.png" />
      <img style="right: 5rem; top: 5rem" class="knd-header__bg_img animate-pulse" src="@/assets/images/header-bubble-3.png" />
      <img style="left: 25%; top: 25%" class="knd-header__bg_img animate-pulse" src="@/assets/images/header-bubble-1.png" />
    </div>

    <div class="knd-header__intro">
      <div class="header-title__wrapper">
        <h1 class="knd-header__title">
          Misleid door verleiding
        </h1>

        <div class="header__lead">
          Hoe chatoperators je aan de praat houden op nepdatingsites
        </div>
      </div>
      <div class="header_scroll">
        <svg viewBox="0 0 496 500" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g filter="url(#filter0_f_0_1)">
          <ellipse cx="248" cy="250" rx="184" ry="186" fill="#FFC5CC"/>
          </g>
          <path class="knd-animate-bounce" d="M245.769 173.049L245.769 149L249.231 149L249.231 173.049C250.062 170.927 251.446 169.064 253.385 167.461C255.323 165.858 257.862 164.891 261 164.561L261 168.098C258.092 168.428 255.6 169.559 253.523 171.493C251.446 173.473 250.015 175.642 249.231 178L245.769 178C244.985 175.642 243.554 173.473 241.477 171.493C239.4 169.559 236.908 168.428 234 168.098L234 164.561C237.138 164.891 239.677 165.858 241.615 167.461C243.554 169.064 244.938 170.927 245.769 173.049Z" fill="black"/>
          <defs>
          <filter id="filter0_f_0_1" x="0" y="0" width="496" height="500" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB">
          <feFlood flood-opacity="0" result="BackgroundImageFix"/>
          <feBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/>
          <feGaussianBlur stdDeviation="32" result="effect1_foregroundBlur_0_1"/>
          </filter>
          </defs>
        </svg>
        </div>
    </div>

    <div class="knd-wrapper knd-wrapper__intro knd-px-5" v-html="intro"></div>

      <TinderWrapper />

  </div>
</template>

<script>
import TinderWrapper from './TinderWrapper.vue';
import Bubbles from './bubbles.js';

export default {
  name: 'App',
  components: { TinderWrapper },
  mounted () {
    new Bubbles(this.$refs.canvas);
  },

  computed: {
    match () {
      return this.$store.state.match.made;
    },
    intro() {
        return this.$store.state.content.intro;
    }
  }, 
}
</script>

<style lang="scss" scoped>
  .header_scroll {
    position: absolute;
    z-index: 100;
    bottom: 60px;
    left: 50%;
    transform: translateX(-50%);

    @screen sm {
      width: 300px;
      bottom: -6rem;
    }

    svg {
      width: 100%;
      height: 100%
    }
  }
  .knd-header {
    overflow-x:hidden;
    position: relative;
  }
  .knd-header__bg_svg {
    position: absolute;
    fill: theme('colors.red.dark');
    z-index: 1;
    transform: translateY(-50%) scaleX(2.5) scaleY(3.5);
    height: 150vh;
    width: 100vw;
    pointer-events: none;

    @screen sm {
      transform: translateY(-50%) scaleX(1.5) scaleY(1.5);
    }

    @screen md {
      transform: translateY(-50%) scaleX(1.2) scaleY(1.2);
    }
}

.knd-header__quote {
  position: absolute;
  top: 30%;
  left: 50%;
  z-index: 1000;
}
.knd-header__bg_img {
  position: absolute;
  width: 76px;
  height: 82px;
  z-index: 1;
}

.knd-header__intro {
  position: relative;
  z-index: 10;
  color: theme('colors.green.light');

  .header-title__wrapper {
    position: absolute;
    top: 40%;
    left: 50%;
    transform: translate(-50%, -50%);

    @screen sm {
      top: 30%;
    }
  }
}

.knd-wrapper__intro {
  position: relative;
  z-index: 100;
}

#canvas {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
}
</style>